import React from "react";
import ReactMarkdown, { Components } from "react-markdown";

import * as styles from "./styles";
import { markdownWithLineBreaks } from "./protocol";

// Replies are chat messages: emphasis, lists and links render, anything larger is flattened to text.
const ALLOWED_ELEMENTS = ["p", "strong", "em", "ul", "ol", "li", "code", "a", "br", "h1", "h2", "h3", "h4", "h5", "h6"];

const Heading: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <p>
    <strong>{children}</strong>
  </p>
);

const components: Components = {
  h1: Heading,
  h2: Heading,
  h3: Heading,
  h4: Heading,
  h5: Heading,
  h6: Heading,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
};

export const ReplyMarkdown: React.FC<{ text: string }> = ({ text }) => (
  <styles.ReplyText>
    <ReactMarkdown allowedElements={ALLOWED_ELEMENTS} unwrapDisallowed skipHtml components={components}>
      {markdownWithLineBreaks(text)}
    </ReactMarkdown>
  </styles.ReplyText>
);
